// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsTwoToneSvg from "@fishx/icons-svg/es/asn/SnippetsTwoTone";
import FishxIcon from '../components/FishxIcon';

var SnippetsTwoTone = function SnippetsTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsTwoToneSvg
  }));
};

SnippetsTwoTone.displayName = 'SnippetsTwoTone';
export default React.forwardRef(SnippetsTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SnippetsTwoTone.js
// module id = 4161
// module chunks = 0